import Vue from 'vue'
import VueRouter from 'vue-router'

import Layout from '@/views/layout.vue'
import Csmar from '@/views/csmar.vue'


Vue.use(VueRouter)

//配置导出路由
export default new VueRouter({
    routes:[{
        path: '/',
        component: Layout
    },
    {
        path: '/csmarpage',
        component: Csmar
    }]
})